import { UpdateSchoolView } from "./SchoolUpdateView";
import { FC } from "react";

export const UpdateSchoolViewContainer: FC = () => {
  return <UpdateSchoolView />;
};
